import { render } from "./NcrmWorkflowDataCollectionEditor.vue?vue&type=template&id=0d7af3f3&scoped=true"
import script from "./NcrmWorkflowDataCollectionEditor.vue?vue&type=script&lang=js"
export * from "./NcrmWorkflowDataCollectionEditor.vue?vue&type=script&lang=js"

import "./NcrmWorkflowDataCollectionEditor.vue?vue&type=style&index=0&id=0d7af3f3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d7af3f3"]])

export default __exports__